{
  "languages": {
    "cz": "Česky",
    "en": "Anglicky",
    "sk": "Slovencina",
    "translateToLangauge": {
      "cz": "Česky",
      "en": "Anglicky",
      "sk": "Slovensky"
    }
  },
  "roles": {
    "copyLinePermission": "Kopírovanie v riadku",
    "copyPermission": "Kopírovanie",
    "createLinePermission": "Tvorba v riadku",
    "createPermission": "Tvorba",
    "deletePermission": "Mazanie",
    "editLinePermission": "Editácia v riadku",
    "editPermission": "Editácia",
    "exportPermission": "Export tabuliek",
    "title": "Helios"
  },
  "recordDetail": {
    "entry": "Položka detail",
    "template": {
      "description": "Popis šablóny:",
      "status": "Stav:",
      "name": "Názov šablóny:",
      "created": "Vytvorené:"
    },
    "recordNotFound": "Záznam sa nenašiel. Presmerovávam na prehľad."
  },
  "templates": {
    "conditions": {
      "actionsTitle": "Akcie",
      "actions": {
        "Edit": "Úprava",
        "EditInRow": "Úprava v riadku",
        "Delete": "Vymazanie",
        "Create": "Vytvorenie",
        "CreateInRow": "Vytvorenie v riadku",
        "Copy": "Kopírovanie",
        "CopyInRow": "Kopírovanie v riadku",
        "Presave": "Preduloženie",
        "ContinuousSave": "Priebežné uloženie",
        "AutomaticValue": "Automatická hodnota"
      },
      "automaticValueSettings": "Nastavenie automatickej hodnoty",
      "targetItem": "Cieľová položka",
      "defaultValue": "Predvolená hodnota",
      "saveCondition": "Uložiť podmienku",
      "condition": {
        "leftBracket": "Ľavá zátvorka",
        "rightBracket": "Pravá zátvorka",
        "and": "A",
        "or": "Alebo",
        "source": "Zdroj",
        "static": "Statická hodnota",
        "value": "Hodnota",
        "empty": "Prázdne",
        "comparisonOperator": "Operátor porovnania",
        "comparisons": {
          "GreaterThan": "Väčšie ako",
          "GreaterThanOrEqual": "Väčšie alebo rovné",
          "LessThan": "Menšie ako",
          "LessThanOrEqual": "Menšie alebo rovné",
          "Empty": "Prázdne",
          "NotEmpty": "Nie je prázdne",
          "Null": "Null",
          "NotNull": "Nie je null",
          "Equals": "Rovná sa",
          "NotEquals": "Nerovná sa",
          "Contains": "Obsahuje",
          "NotContains": "Neobsahuje",
          "Between": "Medzi",
          "DaysBefore": "Dní pred dátumom"
        },
        "selectValue": "Vyberte hodnotu",
        "roles": "Role",
        "roleTags": "Štítky rolí",
        "pickRole": "Konkrétna rola…",
        "pickRoleTag": "Štítok role…",
        "daysBefore": {
          "label": "Počet dní vopred",
          "error": "Zadajte celé číslo 0–3650",
          "sourceError": "Zdroj musí byť dátumové pole"
        }
      },
      "sources": {
        "HeliosUser": "Helios užívateľ",
        "HeliosUserId": "Helios užívateľ ID",
        "UserReference": "Užívateľská referencia",
        "UserRole": "Rola užívateľa",
        "UserEmail": "Email užívateľa",
        "ContactEmail": "Kontaktný email užívateľa",
        "DateTimeNow": "Dátum a čas teraz",
        "DateNow": "Dátum teraz"
      },
      "states": {
        "Visible": "Viditeľnosť",
        "Editable": "Editovateľnosť",
        "DefaultValue": "Predvolená hodnota",
        "AutomaticValue": "Automatická hodnota",
        "Highlight": "Zvýraznenie",
        "Collapsed": "Zbalenie sekcie",
        "Required": "Podmienka povinnosti"
      },
      "parentRecordRef": {
        "parentRecordRelationItemId": "Atribút z nadradeného záznamu",
        "parentRecordRelationItemIdHelper": "Vyberte atribút z nadradeného záznamu pre predvyplnenie tohto poľa"
      },
      "toasts": {
        "errors": {
          "delete": "Chyba pri mazaní podmienky",
          "add": "Chyba pri pridávaní podmienky",
          "edit": "Chyb pri úprave podmienky",
          "stateChanged": "Chyba pri zmene stavu podmienky"
        },
        "success": {
          "delete": "Podmienka bola úspešne zmazaná",
          "add": "Podmienka bola úspešne pridaná",
          "edit": "Podmienka bola úspešne upravená",
          "stateChanged": "Stav podmienky bol úspešne zmenený"
        }
      }
    },
    "notifications": {
      "notificationsTitle": "Nastavenie",
      "notificationTemplate": "Notifikačná šablóna",
      "isTaskNotification": "Je úlohová notifikácia",
      "resolvesTask": "Rieši úlohu",
      "setParametersMapping": "Mapovanie parametrov",
      "functions": "Funkcie",
      "functionsOverview": "Funkcie prehľadu",
      "functionsDetail": "Funkcie detailu",
      "addFunction": "Pridať",
      "functionsSelection": "Výber funkcií",
      "parameter": "Parameter",
      "dataItem": "Stĺpec"
    },
    "invalidDetailTemplateId": "Neplatné ID detailovej šablóny",
    "dataModel": {
      "alias": "Nápoveda možných aliasov",
      "button": "Aplikovať SQL dotaz",
      "label": "SQL dopyt",
      "placeholder": "Tu môžete napísať SQL dopyt",
      "success": "SQL dopyt bol úspešne pridaný",
      "title": "Nastavenie dátového modelu"
    },
    "forms": {
      "buttons": {
        "aggregationGroupItems": "Agregačné skupiny",
        "buttonItems": "Funkcie",
        "columnValueItems": "Hodnoty stĺpcov",
        "externalItems": "Externý záznam",
        "userDefinedItems": "Používateľom definované polia",
        "delimiters": "Oddeľovače",
        "infoText": "Informačný text",
        "infoTextItems": "Informačné texty",
        "horizontalSolidDelimiter": "Horizontálna plná čiara",
        "verticalSolidDelimiter": "Vertikálna plná čiara",
        "horizontalDashedDelimiter": "Horizontálna čiarkovaná čiara",
        "verticalDashedDelimiter": "Vertikálna čiarkovaná čiara",
        "horizontalDottedDelimiter": "Horizontálna bodkovaná čiara",
        "verticalDottedDelimiter": "Vertikálna bodkovaná čiara"
      },
      "globalSettings": "Globálne nastavenia",
      "hasMobileLayout": "Má mobilné rozloženie",
      "hasWebLayout": "Má webové rozloženie",
      "copyWebToMobile": "Kopírovať z webu",
      "copyWebToMobileConfirm": "Naozaj chcete skopírovať rozloženie z webu? Týmto prepíšete aktuálne mobilné rozloženie.",
      "editTab": "Upraviť záložku",
      "deleteTab": "Zmazať záložku",
      "deleteTabConfirm": "Zmazať túto záložku? Sekcie sa presunú na inú záložku. Duplicitné názvy a zodpovedajúce preklady budú premenované.",
      "editSubTab": "Upraviť podsekciu",
      "deleteSubTab": "Zmazať podsekciu",
      "deleteSubTabConfirm": "Naozaj chcete zmazať túto podsekciu? Všetky položky v tejto podsekcii budú odstránené.",
      "subTabUnnamedHint": "Táto podsekcia nemá názov. Kliknite na ikonu menu a pomenujte ju.",
      "collapseConditions": {
        "title": "Podmienky zbalenia sekcie",
        "tooltip": "Podmienky zbalenia",
        "ruleName": "Názov pravidla",
        "addRule": "Pridať pravidlo"
      },
      "item": {
        "basicSettings": {
          "basicInformation": "Základné informácie",
          "displayType": {
            "label": "Typ zobrazenia",
            "value": "Hodnota",
            "staticselection": "Statický výber",
            "browse": "Prehliadať",
            "file": "Súbor",
            "link": "Odkaz",
            "button": "Tlačidlo",
            "calendarname": "Názov kalendára",
            "calendarcategory": "Kategória kalendára",
            "calendardatefrom": "Dátum kalendára od",
            "calendardateto": "Dátum kalendára do",
            "calendarallday": "Celodenný kalendár",
            "infotext": "Informačný text"
          },
          "sorting": "Triedenie",
          "properties": "Vlastnosti",
          "advancedOptions": "Pokročilé možnosti",
          "buttonLabel": "Meno tlačidla",
          "disableTriggerEvents": "Editovať bez inštančnej logiky",
          "ordinalIndex": "Poradie spracovania",
          "isPresaveAllowed": "Povolene predukladanie",
          "showButtonDirectly": "Zobraziť priamo na riadku",
          "label": "Meno",
          "sortOrder": "Poradie triedenia",
          "sortType": {
            "label": "Typ triedenia",
            "none": "Žiadne",
            "ascending": "Vzostupne",
            "descending": "Zostupne"
          },
          "title": "Základné údaje"
        },
        "aggregation": {
          "title": "Agregácia prehľadu",
          "isGrouped": "Zoskupovať",
          "groupingOrder": "Poradie zoskupenia",
          "aggregationType": "Vypočítať ako",
          "groupedTooltip": "Pri prvku je nastavené zoskupenie / agregácia"
        },
        "formatting": {
          "alignment": "Zarovnanie",
          "specificFormatting": "Špecifické formátovanie",
          "align": {
            "center": "Na stred",
            "left": "Vľavo",
            "right": "Vpravo"
          },
          "dateTime": {
            "date": "Dátum",
            "datetime": "Dátum a čas",
            "label": "Formát dátumu",
            "monthYear": "Mesiac / rok",
            "time": "Čas"
          },
          "labelAlign": "Zarovnanie štítku",
          "mathRound": {
            "arithmetic": "Aritmetické",
            "down": "Nadol",
            "label": "Matematické zaokrúhlenie",
            "up": "Nahor"
          },
          "maxValue": "Maximálna hodnota",
          "minValue": "Minimálna hodnota",
          "minGreaterThanMax": "Minimálna hodnota nesmie byť väčšia ako maximálna hodnota",
          "roundTo": {
            "tenthousandths": "Zaokrúhlenie na najbližšie desaťtisíciny",
            "thousandths": "Zaokrúhlenie na najbližšie tisíciny",
            "hundredths": "Zaokrúhlenie na najbližšie stotiny",
            "tenths": "Zaokrúhlenie na najbližšie desatiny",
            "dozens": "Zaokrúhlenie na najbližšie desiatky",
            "hundreds": "Zaokrúhlenie na najbližšie stovky",
            "thousands": "Zaokrúhlenie na najbližšie tisícky",
            "label": "Zaokrúhliť na"
          },
          "separator": {
            "none": "Žiadny",
            "comma": "Čiarka",
            "dot": "Bodka",
            "label": "Oddeľovač tisícov",
            "space": "Medzera"
          },
          "showAsTime": "Zobraziť ako čas",
          "showAsTextArea": "Zobraziť ako textovú oblasť",
          "showPhoneOrMail": "Zobraziť ako telefón alebo email",
          "showWebLink": "Zobraziť ako webový odkaz",
          "showAsRichText": "Zobraziť ako Rich Text",
          "specialChars": "Špeciálne znaky",
          "title": "Formátovanie",
          "unit": "Jednotka",
          "valueAlign": "Zarovnanie hodnoty",
          "buttonAlign": "Zarovnanie tlačidla",
          "labelLayout": {
            "label": "Rozloženie štítku",
            "sideBySide": "Vedľa seba",
            "stacked": "Pod sebou"
          }
        },
        "settings": {
          "dynamicRelations": "Dynamické vzťahy",
          "fileFolder": "Priečinok súborov",
          "targetTemplate": "Cieľová šablóna",
          "browse": {
            "dataSources": "Zdroje dát",
            "columnConfiguration": "Konfigurácia stĺpcov",
            "advancedOptions": "Pokročilé možnosti",
            "filtering": "Filtrovanie",
            "conditions": "Podmienky",
            "allowMultipleSelection": "Povoliť viacnásobný výber",
            "displayColumns": "Zobrazované stĺpce",
            "displayColumnsHelp": "Pretiahnite stĺpce na zmenu ich poradia",
            "valueColumn": "Stĺpec hodnoty",
            "allowMultipleSelectionHint": "Viacnásobný výber je možné len pri nastavenom dynamickom vzťahu",
            "codeListTemplate": "Číselníková šablóna",
            "detailTemplate": "Detailová šablóna",
            "dynamicRelation": "Dynamický vzťah",
            "entryTemplate": "Položková šablóna"
          },
          "file": {
            "folder": "Priečinok",
            "viewMode": "Režim zobrazenia",
            "viewModeTitle": "Režim zobrazenia príloh",
            "viewModeIcons": "Veľké ikony",
            "viewModeCompact": "Kompaktný zoznam"
          },
          "staticSelection": {
            "title": "Statické možnosti",
            "key": "V databáze",
            "value": "Zobraziť ako"
          },
          "infoText": {
            "content": "Obsah (rich text)",
            "title": "Informačný text",
            "empty": "Nie je k dispozícii žiadny obsah",
            "emptyHint": "Zatiaľ nevyplnené",
            "filled": "vyplnených",
            "copyToAll": "Kopírovať do všetkých jazykov",
            "edit": "Upraviť obsah"
          },
          "title": "Nastavenia"
        }
      },
      "saveSuccess": "Formulár bol úspešne uložený",
      "inheritedHighlightConditionName": "Podmienka zvýraznenia",
      "inheritedVisibilityConditionName": "Podmienka viditeľnosti",
      "warning": {
        "removeItem": "Naozaj chcete odstrániť položku?",
        "tabNameExists": "Tento názov záložky už existuje"
      }
    },
    "functions": {
      "button": {
        "add": "Pridať funkciu",
        "orderButtons": "Nastaviť poradie tlačidiel"
      },
      "selectDetailTemplateModal": {
        "title": "Vybrať detail šablóny"
      },
      "selectFunctionModal": { "title": "Vyberte funkciu" },
      "addFunctionModal": {
        "requiresSaveBeforeExecution": "Vyžadovať uloženie pred spustením",
        "allowMultipleSelection": "Povoliť spustenie nad viacerými záznamami",
        "showAsStandaloneButton": "Zobraziť ako samostatné tlačidlo",
        "showAsStandaloneButtonDisabledBecauseItIsCommon": "Bežné funkcie sú vždy zobrazené ako samostatné tlačidlo.",
        "requiresConfirmation": "Vyžadovať potvrdenie pri spustení",
        "openCreatedRecord": "Otvoriť vytvorený záznam",
        "openCreatedRecordTemplateId": "Šablóna pre otvorenie vytvoreného záznamu",
        "title": "Pridať funkciu",
        "titleUpdate": "Upraviť funkciu",
        "funcitonName": "Názov funkcie",
        "tooltip": "Štítek",
        "aliasPc": "Alias PC",
        "aliasMobile": "Alias Mobile",
        "iconPc": "Ikona PC",
        "iconMobile": "Ikona Mobile",
        "colorPc": "Farba PC",
        "colorMobile": "Farba Mobile",
        "addParameter": "Pridať parameter",
        "displayConditions": "Podmienky zobrazenia"
      },
      "orderButtonsModal": {
        "title": "Nastaviť poradie tlačidiel",
        "description": "Presunutím funkcií nastavíte poradie tlačidiel.",
        "toasts": {
          "success": "Poradie tlačidiel bolo uložené"
        }
      },
      "triggerFunctionModal": {
        "title": "Spustiť funkciu",
        "comment": "Komentár",
        "success": "Funkcia bola úspešne spustená",
        "error": "Nastala chyba pri spúšťaní funkcie"
      },
      "confirmFunctionModal": {
        "title": "Potvrdiť akciu",
        "text": "Chcete spustiť funkciu {{name}}?"
      },
      "parameterModal": {
        "titleAdd": "Pridať parameter",
        "titleEdit": "Upraviť parameter",
        "titleView": "Zobraziť parameter",
        "name": "Názov",
        "labelText": "Štítok",
        "type": "Typ",
        "order": "Poradie",
        "isRequired": "Povinný",
        "isMultiSelect": "Povoliť výber viacerých záznamov",
        "templateBrowseId": "Číselníková šablóna",
        "prefilter": {
          "title": "Podmienky predfiltrovania",
          "conditions": "Podmienky",
          "updated": "Podmienky predfiltovania aktualizované",
          "addPrefilter": "Pridať predfilter",
          "condition": "Podmienka {{index}}",
          "description": "Pri výbere hodnoty sa v číselníku zobrazia len záznamy spĺňajúce všetky podmienky.",
          "empty": "Zatiaľ žiadne podmienky — číselník sa zobrazí nefiltrovaný."
        },
        "options": "Možnosti",
        "addOption": "Pridať možnosť",
        "optionKey": "Názov",
        "optionValue": "Hodnota",
        "toasts": {
          "success": {
            "add": "Parameter bol úspešne pridaný",
            "edit": "Parameter bol úspešne upravený"
          }
        }
      }
    },
    "settings": {
      "dataSource": "Dátový zdroj",
      "device": {
        "label": "Zariadenie",
        "mobile": "Mobil",
        "web": "Web",
        "webAndMobile": "Web aj mobil"
      },
      "displayAs": "Zobraziť ako",
      "name": "Interný názov šablóny",
      "heg": {
        "label": "Trieda a zakladač",
        "classes": "Trieda",
        "folders": "Zakladač"
      },
      "module": "Modul",
      "selectModuleModal": { "title": "Vyberte modul" },
      "selectDataSourceModal": { "title": "Vyberte dátový zdroj" },
      "selectTableModal": { "title": "Vyberte tabuľku" },
      "order": "Poadie šablóny",
      "related": {
        "button": "+ Pridať nadriadenú šablónu",
        "columns": {
          "label": "Spojovacie stĺpce",
          "modal": {
            "title": "Spojovacie stĺpce",
            "linkColumn": "Spojovací stĺpec ({{type}})"
          }
        },
        "label": "Nadriadená šablóna",
        "modal": {
          "title": "Vybrať nadriadenú šablónu",
          "template": "Vybrať nadriadenú šablónu",
          "type": "Vybrať typ nadriadenej šablóny"
        }
      },
      "table": "Tabuľka",
      "template": "Šablóna",
      "type": {
        "api": "API číselník",
        "calendar": "Kalendár",
        "codelist": "Číselník",
        "detail": "Detail",
        "entry": "Položka",
        "label": "Typ šablóny",
        "overview": "Prehľad"
      },
      "visibility": "Viditeľnosť"
    },
    "templateImport": "Import šablóny",
    "templateCopy": "Kopírovanie šablóny",
    "copyDisabledTooltip": "Pre kopírovanie šablóny vyberte prosím práve jednu šablónu zo zoznamu.",
    "templateCopySuccess": "Šablóna bola úspešne skopírovaná",
    "deleteTemplateModal": {
      "title": "Zmazať šablónu",
      "titlePlural": "Zmazať šablóny",
      "message": "Naozaj chcete zmazať túto šablónu? Táto akcia je nevratná.",
      "messagePlural": "Naozaj chcete zmazať vybrané šablóny? Táto akcia je nevratná.",
      "success": "Šablóna bola úspešne zmazaná",
      "error": "Šablónu sa nepodarilo zmazať"
    },
    "exportTemplate": "Export šablón",
    "exportDescription": "Zaškrtnutím šablóny sa exportujú aj naviazané šablóny",
    "exportSummaryTitle": "Náhľad obsahu exportu",
    "exportWithRelatedLabel": "s naviazanými šablónami",
    "exportOnlyThisLabel": "iba táto šablóna",
    "userDefinedField": {
      "addAggregationGroup": "Pridať agregačnú skupinu",
      "addGroup": "Pridať skupinu",
      "addItem": "Pridať položku",
      "editAggregationGroup": "Upraviť agregačnú skupinu",
      "editGroup": "Upraviť skupinu",
      "dataModelItem": "Položka dátového modelu",
      "placeholder": {
        "group": "Pojmenujte skupinu",
        "value": "Zadajte hodnotu"
      },
      "type": {
        "none": "Žiadne",
        "count": "Počet",
        "avg": "Priemer",
        "min": "Minimum",
        "max": "Maximum",
        "attribute": "Z modelu",
        "concatenate": "Spojenie reťazcov",
        "date": "Dátum",
        "static": "Statická hodnota",
        "sum": "Suma",
        "time": "Čas"
      }
    },
    "printConfigurations": {
      "title": "Konfigurácie tlače",
      "reportId": "Číslo tlačovej šablóny",
      "name": "Názov tlače",
      "description": "Popis",
      "order": "Poradie",
      "active": "Aktívny",
      "add": "Pridať konfiguráciu tlače",
      "edit": "Upraviť konfiguráciu tlače",
      "sections": {
        "basic": "Základné údaje",
        "output": "Výstup",
        "reportDefinition": "Definícia zostavy",
        "filter": "Filter prehľadovej zostavy",
        "arguments": "Argumenty zostavy"
      },
      "target": "Cieľ tlače",
      "targets": {
        "file": "Súbor",
        "printer": "Tlačiareň"
      },
      "fileFormat": "Formát súboru",
      "printerName": "Názov tlačiarne",
      "copiesNumber": "Počet kópií",
      "folderId": "Číslo poradača",
      "fileName": "Názov súboru na serveri",
      "returnFileContent": "Vrátiť obsah súboru",
      "reportType": "Typ zostavy",
      "reportTypes": {
        "form": "Formulár",
        "browse": "Prehľad",
        "pureBrowse": "Prehľad bez filtrácie"
      },
      "reportName": "Názov zostavy",
      "libraryName": "Názov knižnice",
      "classId": "Číslo triedy",
      "filterFolderId": "Poradač filtra",
      "filterId": "Číslo filtra",
      "argumentName": "Názov argumentu",
      "argumentValue": "Hodnota",
      "argumentSkip": "Preskočiť",
      "addArgument": "Pridať argument",
      "notSet": "Nenastavené (predvolené)",
      "tooltips": {
        "title": "Tlačové šablóny",
        "noPrintConfigurations": "Žiadne tlačové konfigurácie",
        "selectRecordsToPrint": "Vyberte záznamy na tlač",
        "printSuccess": "Tlačová operácia bola úspešne dokončená",
        "reportId": "Číslo tlačovej zostavy v Heliu",
        "target": "Cieľ tlače – súbor alebo tlačiareň",
        "fileFormat": "Formát súboru, ak je zvolená tlač do súboru",
        "printerName": "Názov tlačiarne, ak je zvolená tlač na tlačiareň",
        "copiesNumber": "Počet kópií. Použije sa len pri tlači na tlačiareň, pri exporte do súboru sa ignoruje",
        "fileName": "Plný názov súboru na serveri pri tlači do súboru. Ak je zapnuté „Vrátiť obsah súboru“, nemusí byť zadaný – použije sa dočasný súbor na serveri",
        "folderId": "Číslo poradača, ak je vybraná prehľadová (nie formulárová) zostava",
        "returnFileContent": "Či sa pri tlači do súboru vráti obsah súboru (pole bajtov)",
        "reportType": "Druh zostavy – formulárová, prehľadová s filtrovaním, alebo prehľadová bez filtrovania (vytlačia sa všetky dáta podľa selektu, neaplikujú sa permanentné filtre ani práva)",
        "reportName": "Názov zostavy definovanej v knižnici",
        "libraryName": "Názov knižnice, v ktorej je zostava definovaná",
        "classId": "Číslo triedy",
        "filterFolderId": "Číslo poradača filtra",
        "filterId": "Číslo filtra",
        "argumentName": "Názov parametra",
        "argumentValue": "Hodnota parametra",
        "argumentSkip": "Preskočiť argument pri spracovaní argumentov filtra"
      }
    },
    "versions": {
      "create": "Vytvoriť novú verziu",
      "label": "Výber verzií"
    },
    "filters": {
      "title": "Filtre",
      "activeFilters": "Aktívne filtre",
      "noActiveFilters": "Žiadne aktívne filtre",
      "addFilter": "Pridať filter",
      "editFilter": "Upraviť filter",
      "column": "Stĺpec",
      "operator": "Operátor",
      "value": "Hodnota",
      "logicalOperator": "Logický operátor",
      "selectValue": "Vyberte hodnotu",
      "apply": "Potvrdiť filtre",
      "updateFilter": "Aktualizovať filter",
      "savedFilters": "Uložené filtre",
      "noSavedFilters": "Žiadne uložené filtre",
      "saveFilter": "Uložiť filter",
      "deleteFilter": "Zmazať filter",
      "defaultFilter": "Predvolený",
      "filterName": "Názov filtra",
      "filterNamePlaceholder": "Zadajte názov filtra",
      "setAsDefault": "Nastaviť ako predvolený",
      "loadFilter": "Načítať filter",
      "filterSaved": "Filter bol úspešne uložený",
      "filterDeleted": "Filter bol úspešne zmazaný",
      "filterLoaded": "Filter bol načítaný",
      "isBlank": "Prázdne",
      "isBlankEmpty": "Filtrovať prázdne",
      "isBlankNotEmpty": "Filtrovať neprázdne",
      "fromValue": "Od",
      "toValue": "Do",
      "advancedMode": "Rozšírené",
      "addValue": "Pridať hodnotu",
      "pressEnter": "Enter pre pridanie"
    }
  },
  "datasources": {
    "title": "Dátové zdroje",
    "createDataSource": "Vytvoriť dátový zdroj",
    "editDataSource": "Upraviť dátový zdroj",
    "loginPurposes": {
      "placeholder": "Vyberte zo zoznamu",
      "none": "Žiadne",
      "user": "Používateľ",
      "serviceAccount": "Servisný účet",
      "both": "Používateľ a Servisný účet"
    },
    "deleteDatasourcesModal": {
      "title": "Odstrániť dátový zdroj",
      "titlePlural": "Odstrániť dátové zdroje",
      "message": "Naozaj chcete odstrániť dátový zdroj?",
      "messagePlural": "Naozaj chcete odstrániť dátové zdroje?",
      "submit": "Odstrániť",
      "success": "Dátový zdroj bol úspešne odstránený",
      "error": "Nepodarilo sa odstrániť dátový zdroj"
    },
    "form": {
      "name": "Názov",
      "namePlaceholder": "Zadajte názov",
      "timeZone": "Časové pásmo",
      "profile": "Profil",
      "profilePlaceholder": "Zadajte názov profilu",
      "url": "URL",
      "urlPlaceholder": "Zadajte URL",
      "basicLoginPurpose": "Nedoménové mapovanie",
      "domainLoginPurpose": "Doménové mapovanie",
      "domain": "Doména",
      "domainPlaceholder": "Zadajte doménu",
      "googleLoginPurpose": "Google mapovanie",
      "microsoftLoginPurpose": "Microsoft mapovanie",
      "maxConcurrentConnections": "Max. počet súbežných používateľov",
      "sections": {
        "general": "Základné nastavenie",
        "loginMethods": "Prihlasovacie metódy",
        "accountMapping": "Mapovanie účtov"
      },
      "defaultUserMapping": "Predvolené mapovanie používateľa",
      "useDefaultUserMapping": "Používať predvolené mapovanie používateľa",
      "defaultUserMappingError": "Pridajte mapovanie alebo vypnite možnosť \"{{useDefaultUserMapping}}\"",
      "serviceAccount": "Servisný účet",
      "map": "Namapovať",
      "unmap": "Odmapovať",
      "mappedAccount": "Namapovaný účet",
      "notMapped": "Nenamapované",
      "userMapping": "Mapovanie používateľa",
      "userName": "Používateľské meno",
      "userNamePlaceholder": "Zadajte používateľské meno",
      "password": "Heslo",
      "passwordPlaceholder": "Zadajte heslo",
      "type": "Typ prihlásenia"
    },
    "mapping": {
      "domain": "Doména",
      "google": "Google",
      "login": "Meno a heslo",
      "microsoft": "Microsoft",
      "noMapping": "Žiadne možnosti mapovania",
      "authWindowError": "Chyba pri otvorení prihlasovacieho okna",
      "success": "Boli ste úspešne namapovaní",
      "error": "Mapovanie sa nepodarilo",
      "removeMappingTitle": "Zrušiť mapovanie",
      "removeMappingConfirm": "Naozaj chcete zrušiť uložené mapovanie?",
      "removeMappingSubmit": "Zrušiť mapovanie",
      "removeMappingSuccess": "Mapovanie bolo úspešne zrušené",
      "removeMappingError": "Mapovanie sa nepodarilo zrušiť",
      "invalidMapping": "Uložené mapovanie k dátovému zdroju už nie je platné. Namapujte sa prosím znova."
    },
    "users": {
      "edit": "Úprava mapovania používateľov",
      "modal": {
        "title": "Odmapovanie používateľa",
        "delete": {
          "title": "Odstrániť mapovanie používateľa",
          "message": "Naozaj si želáte odstrániť mapovanie používateľa?",
          "submit": "Odstrániť",
          "success": "Mapovanie používateľa bolo úspešne odstránené",
          "error": "Mapovanie používateľa sa nepodarilo odstrániť"
        }
      }
    }
  },
  "tables": {
    "title": "Tabuľky",
    "deleteConfirmation": "Naozaj chcete zmazať vybrané tabuľky? Táto akcia je nevratná.",
    "modalAddtable": {
      "addColumn": "Pridať stĺpec",
      "columnName": "Názov stĺpca",
      "editColumn": "Upraviť stĺpec",
      "error": {
        "missingColumns": "Tabuľka musí obsahovať aspoň jeden stĺpec",
        "uniqueName": "Názov tabuľky musí byť unikátny"
      },
      "tableName": "Názov tabuľky",
      "tableNamePlaceholder": "Zadajte názov tabuľky",
      "title": {
        "_": "Pridať tabuľku",
        "create": "Pridať tabuľku",
        "edit": "Upraviť tabuľku",
        "selectDataSource": "Vyberte dátový zdroj",
        "selectTable": "Vyberte tabuľku"
      },
      "sorting": {
        "label": "Triedenie tabuliek",
        "asc": "Od A po Z",
        "desc": "Od Z po A"
      },
      "unique": "Stĺpec je unikátny"
    },
    "successfully": {
      "created": "Tabuľky boli úspešne vytvorené",
      "deleted": "Tabuľky boli úspešne zmazané",
      "updated": "Tabuľky boli úspešne upravené"
    }
  },
  "notificationTemplates": {
    "form": {
      "addParameter": "Pridať parameter",
      "email": "Emailová notifikácia",
      "insertParam": "Vložiť parameter",
      "name": "Názov notifikácie",
      "parameter": "Názov parametra",
      "parameterExists": "Tento parameter už existuje",
      "parameterRequired": "Názov parametra je povinný pre pridanie parametra",
      "push": "Push notifikácia",
      "subject": "Predmet",
      "text": "Text notifikácie",
      "web": "Notifikácia v aplikácii",
      "description": "Popis",
      "title": "Názov"
    },
    "confirmationModalForLeaving": {
      "title": "Naozaj chcete opustiť túto stránku?",
      "description": "Kliknutím na potvrdenie odídete zo stránky a stratíte neuložené dáta."
    },
    "confirmationModalForRemoving": {
      "title": "Naozaj si želáte odstrániť túto notifikačnú šablónu?",
      "description": "Kliknutím na potvrdenie bude šablóna odstránená."
    },
    "title": {
      "listOfTemplates": "Zoznam notifikačných šablón",
      "newConditions": "Nové podmienky"
    }
  },
  "functions": {
    "title": "Funkce",
    "tooltips": {
      "noFunctions": "Žiadne funkcie"
    },
    "toasts": {
      "error": "Niečo sa nepodarilo",
      "errors": {
        "delete": "Nepodarilo sa zmazať funkciu",
        "edit": "Nepodarilo sa upraviť funkciu",
        "add": "Nepodarilo sa pridať funkciu",
        "import": "Nepodarilo sa importovať funkciu"
      },
      "success": {
        "delete": "Funkcia bola úspešne zmazaná",
        "edit": "Funkcia bola úspešne upravená",
        "add": "Funkcia bola úspešne pridaná",
        "import": "Funkcia bola úspešne importovaná"
      }
    },
    "addFunctionTranslation": {
      "title": "Pridať funkciu",
      "buttons": {
        "add": "Pridať",
        "cancel": "Zrušiť"
      }
    },
    "addFunctionModal": {
      "title": "Pridať funkciu",
      "description": "Importuje definíciu funkcie z Heliosu a automaticky nastaví parametre.",
      "buttons": {
        "add": "Uložiť",
        "cancel": "Zrušiť",
        "addParameters": "Pridať parametre"
      },
      "fields": {
        "sections": {
          "basicInfo": "Základné údaje",
          "parameters": "Parametre funkcie",
          "settings": "Ostatné nastavenia"
        },
        "name": "Názov",
        "id": "ID funkcie Helios",
        "isCommon": "Je bežná",
        "isEntryFunction": "Vstupná funkcia",
        "dataSource": "Dátový zdroj",
        "column": "Stĺpec",
        "functionType": "Typ",
        "functionTypes": {
          "Heg": "Funkcia",
          "HegWorkflow": "Workflow akcia"
        },
        "skipEntriesWithError": "Preskočiť položky s chybou",
        "parentColumn": "Stĺpec rodiča",
        "functionWorkflowCommentType": "Typ komentára",
        "worflowCommentType": {
          "none": "Žiadne",
          "optional": "Voliteľné",
          "required": "Povinné"
        }
      }
    },
    "importFunctionModal": {
      "title": "Importovať funkciu",
      "buttons": {
        "add": "Importovať",
        "cancel": "Zrušiť",
        "addParameters": "Pridať parametre"
      },
      "fields": {
        "sections": {
          "basicInfo": "Základné údaje",
          "importSettings": "Nastavenie importu"
        },
        "name": "Názov",
        "column": "Stĺpec",
        "functionType": "Typ",
        "id": "ID funkcie Helios",
        "idTooltip": "Číslo akcie (napr. 1205493) z prehľadu Funkcie / Externé akcie v Heliose.",
        "isCommon": "Je bežná",
        "isCommonTooltip": "Ak je zapnuté, funkcia bude dostupná globálne. Ak je vypnuté, bude viazaná na konkrétny dátový zdroj.",
        "importCodeListTemplates": "Importovať číselníkové šablóny",
        "importCodeListTemplatesHelp": "Platí iba pre statické parametre typu Relation. Po zapnutí vyberte modul, do ktorého budú nové šablóny zaradené.",
        "module": "Modul",
        "isEntryFunction": "Vstupná funkcia",
        "parentColumn": "Stĺpec rodiča",
        "dataSource": "Dátový zdroj",
        "paramjson": "Parameter JSON",
        "skipEntriesWithError": "Preskočiť položky s chybou",
        "functionWorkflowCommentType": "Typ komentára",
        "worflowCommentType": {
          "none": "Žiadne",
          "optional": "Voliteľné",
          "required": "Povinné"
        }
      }
    },
    "addFunctionParametersModal": {
      "title": "Detail parametra",
      "buttons": {
        "add": "Importovať",
        "addOption": "Pridať možnosť",
        "cancel": "Zrušiť",
        "addKeyValue": "Pridať",
        "addParameters": "Pridať parametre",
        "select": "Vybrať",
        "selectOverviewTemplate": "Vybrať prehľadovú šablónu",
        "update": "Aktualizovať"
      },
      "fields": {
        "name": "Názov",
        "type": "Typ",
        "label": "Popis",
        "maxCharCount": "Maximálny počet znakov (len pre textové pole/textovú oblasť)",
        "overviewSelect": "Číselník",
        "key": "Kľúč",
        "value": "Hodnota",
        "isRequired": "Je povinný",
        "isMultiSelect": "Povoliť výber viacerých záznamov",
        "order": "Poradie parametra",
        "options": "Možnosti"
      },
      "types": {
        "Text": "Text",
        "Relation": "Výber z prehľadu",
        "Checkbox": "Zaškrtávacie pole",
        "Date": "Dátum",
        "Time": "Čas",
        "DateTime": "Dátum a čas",
        "Radio": "Výber jednej možnosti",
        "Password": "Heslo",
        "File": "Súbor",
        "MultiSelect": "Statický výber"
      }
    },
    "editFunctionModal": {
      "title": "Upraviť detail riadku",
      "buttons": {
        "add": "Pridať",
        "cancel": "Zrušiť",
        "addParameters": "Pridať parametre"
      },
      "fields": {
        "id": "ID funkcie Helios",
        "name": "Názov",
        "column": "Stĺpec",
        "type": "Typ",
        "isCommon": "Je bežná",
        "isEntryFunction": "Vstupná funkcia",
        "skipEntriesWithError": "Preskočiť položky s chybou",
        "parentColumn": "Rodičovský stĺpec",
        "dataSource": "Dátový zdroj",
        "functionWorkflowCommentType": "Typ komentára",
        "worflowCommentType": {
          "none": "Žiadne",
          "optional": "Voliteľné",
          "required": "Povinné"
        }
      }
    },
    "deleteFunctionsModal": {
      "title": "Zmazanie funkcie",
      "description": "Naozaj si želáte odstrániť túto funkciu? Táto akcia je nevratná.",
      "buttons": {
        "delete": "Zmazať",
        "cancel": "Zrušiť"
      }
    }
  },
  "copyInRow": {
    "copy": "Kopírovať",
    "copyInRow": "Kopírovať v riadku"
  },
  "importTemplates": {
    "classFolders": "ID tried a priečinkov",
    "notificationTemplates": "Notifikačné šablóny",
    "runImport": "Spustiť import",
    "templateFunctions": "Funkcie šablóny",
    "classFoldersModal": {
      "classIdExists": "Trieda s týmto ID už existuje",
      "title": "Upraviť ID triedy a priečinok"
    },
    "notificationTemplatesModal": {
      "new": "Nová notifikačná šablóna",
      "title": "Upraviť notifikačnú šablónu",
      "original": "Pôvodná notifikačná šablóna"
    },
    "importTemplateModal": {
      "exportedTemplate": "Exportovaná šablóna",
      "successfulyImported": "Šablóna bola úspešne importovaná",
      "title": "Importovať šablónu",
      "uploadTemplate": "Nahrať šablónu"
    },
    "templateFunctionsModal": {
      "new": "Nová funkcia šablóny",
      "title": "Upraviť funkciu šablóny",
      "original": "Pôvodná funkcia šablóny"
    },
    "importMode": {
      "label": "Režim importu",
      "newVersion": "Nová verzia",
      "freshCopy": "Nová kópia",
      "newVersionDesc": {
        "exists": "Táto šablóna už existuje. Importom bude archivovaná aktuálna verzia.",
        "notExists": "Táto šablóna v tomto prostredí ešte neexistuje. Bude vytvorená."
      },
      "freshCopyDesc": {
        "exists": "Táto šablóna už existuje. Bude vytvorená nová samostatná kópia — existujúca šablóna zostane nezmenená.",
        "notExists": "Táto šablóna ešte neexistuje. Bude vytvorená samostatná kópia."
      }
    },
    "warnings": {
      "title": "Upozornenia",
      "dismiss": "Zavrieť",
      "browseTargetNotInBundle": "Odkaz prehliadania mimo balíka",
      "linkTargetNotInBundle": "Odkaz odkazu mimo balíka",
      "functionNotAutoResolved": "Funkcia vyžaduje ručné mapovanie",
      "realTimeFunctionOrphaned": "Odkaz na real-time funkciu bude odstránený"
    },
    "autoResolved": "Automaticky vyriešené",
    "state": {
      "failed": "Zlyhalo"
    }
  },
  "listing": {
    "errorLoadData": "Chyba pri načítaní dát z Heliosu, skúste to prosím znova neskôr",
    "delete": {
      "confirm": "Naozaj chcete zmazať tento záznam?"
    },
    "exportModal": {
      "title": "Exportovať šablónu {{name}}",
      "titleDetail": "Exportovať položkovú šablónu {{name}}",
      "fileName": "Názov súboru",
      "fileType": "Typ súboru",
      "pagesToExport": "Počet strán na export (1-{{count}})",
      "exportAllPages": "Exportovať všetky stránky",
      "success": "Tabuľka bola úspešne exportovaná",
      "tableType": "Typ tabuľky",
      "tableTypes": {
        "table": "Položky",
        "tableDetail": "Detail a položky"
      }
    },
    "navigateError": "Pri otváraní záznamu došlo k chybe",
    "success": {
      "deleteRow": "Záznam bol úspešne vymazaný",
      "editRow": "Záznam bol úspešne upravený",
      "createRow": "Záznam bol úspešne vytvorený"
    },
    "error": {
      "editRow": "Záznam {{rowId}} sa nepodarilo uložiť."
    },
    "calendar": {
      "table": "Tabuľka",
      "calendar": "Kalendár",
      "view": "Zobraziť",
      "edit": "Upraviť",
      "delete": "Zmazať",
      "noDetailTemplate": "Kalendár nemá priradenú detailnú šablónu, preto nie je možné pridávať záznamy.",
      "noPermission": "Nemáte oprávnenie pridávať záznamy v tomto kalendári."
    }
  }
}
